// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticlePage_wrapper__Muf0f"};